import {BaseIdModel} from "../../models/base-id.model";

export class LocalizationModel extends BaseIdModel {

  constructor(init?: Partial<LocalizationModel>) {
    super();
    return Object.assign(this, init);
  }

  Key: string;
  Value: string;
  LanguageId: string;
  $selected: boolean = true;
  IsDeleted: boolean = false;
}
